import React from "react"

import { Size } from "~tailwindui/types/enums"

import CloudroomButton from "components/CloudroomButton"
import { path } from "components/Tutor/TutorRoutes"

export type TutorCloudroomButtonProps = {
  startsAt: string
  id: string
  className?: string
  disabled?: boolean
  buttonSize?: Size
}

const TutorCloudroomButton: React.FC<TutorCloudroomButtonProps> = ({
  startsAt,
  id,
  className,
  disabled = false,
  buttonSize = Size.Small,
}) => {
  return (
    <CloudroomButton
      startsAt={startsAt}
      href={`/tutor${path("sessionCloudroom", {
        id,
      })}`}
      text="Join Now"
      className={className}
      tailwind
      compact
      disabled={disabled}
      buttonSize={buttonSize}
    />
  )
}

export default TutorCloudroomButton
